import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "px-4 space-y-6" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "pr-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_DataWrapper, {
        label: "ID Configurable",
        class: "w-6/12",
        value: _ctx.detailData.id
      }, null, 8, ["value"]),
      _createVNode(_component_DataWrapper, {
        label: "Nama Harga",
        class: "w-6/12",
        value: _ctx.detailData.configurablePriceName
      }, null, 8, ["value"]),
      _createVNode(_component_DataWrapper, {
        label: "Deskripsi",
        class: "w-8/12",
        value: _ctx.detailData.configurablePriceDescription
      }, null, 8, ["value"])
    ]),
    _hoisted_3
  ]))
}